import { AxiosError } from "axios";
import { handleApiError } from "./instanceApi";
import { moodleInstanceApi } from "./moodleInstanceApi";

export const getForumDisscusions = async (forumId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_forum_get_forum_discussions",
          forumid: forumId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const createDiscussion = async (formData: any) => {
  try {
    const response = await moodleInstanceApi.post(
      "/webservice/rest/server.php",
      formData,
      {
        params: {
          wsfunction: "mod_forum_add_discussion",
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getDiscussionPosts = async (discussionId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_forum_get_discussion_posts",
          discussionid: discussionId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const addDiscussionPost = async (formData: any) => {
  try {
    const response = await moodleInstanceApi.post(
      "/webservice/rest/server.php",
      formData,
      {
        params: {
          wsfunction: "mod_forum_add_discussion_post",
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const deleteDiscussionPost = async (postId: any) => {
  try {
    const response = await moodleInstanceApi.delete(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_forum_delete_post",
          postid: postId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getAllForum = async (params?: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_forum_get_forums_by_courses",
          "courseids[0]": params,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
}
export const viewForum = async (forumid : any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_forum_view_forum",
          forumid: forumid,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
}
